import { v4 as v4uuid } from "uuid";
import { getCurrentUser } from "./session";
import { PoliceManifestationGeneral } from "../Model/PoliceManifestationGeneral";
export class PoliceManifestationGeneralService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOneByDiligenceNumber(ndiligencia) {
        if (ndiligencia) {
            const response = await this.apiService.get('policemanifestationgeneral/' + ndiligencia);
            if (!response.ok) {
                throw new Error(`Error al obtener la extensión de General manifestacion policial`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener nDiligencia`);
        }
    }
    async savePoliceManifestationGeneral(policeManifestation) {
        if (policeManifestation) {
            const response = await this.apiService.post('policemanifestationgeneral', policeManifestation);
            if (!response.ok) {
                throw new Error(`Error al guardar la la extensión de General manifestación policial.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener la manifestación policial.`);
        }
    }
    async createPoliceManifestationGeneral(diligenceId) {
        if (diligenceId) {
            const policeManifestationGeneral = new PoliceManifestationGeneral({
                id: v4uuid(),
                ndiligencia: diligenceId,
                userId: getCurrentUser().id,
                ocularInspection: false,
                eyeInspectionResult: ' ',
                samplesInvolved: false,
                sampleTypes: " ",
                weaponsIntervene: false,
                typesWeapons: " ",
                armsWithdrawalProcedure: false,
                interestingData: " ",
                transferHealthCenter: false,
                accompanyAddressEffects: false,
                accompanyFamilyHome: false,
                transferReceptionCenter: false,
                observations: " ",
                referralDate: new Date(),
                numFoliosRemission: null,
                numReferralMinutes: null,
                independentMinutes: " ",
                numCitations: null,
                citations: " ",
                bodyTransfer: null,
            });
            const response = await this.apiService.post('policemanifestationgeneral', policeManifestationGeneral.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar diligencia general`);
            }
            return policeManifestationGeneral;
        }
        else {
            throw new Error(`Error al obtener la diligencia genral`);
        }
    }
}
